import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import(/* webpackChunkName: "terms" */ '../views/Terms.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import(/* webpackChunkName: "support" */ '../views/Support.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "support" */ '../views/About.vue')
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: () => import(/* webpackChunkName: "support" */ '../views/Subscribe.vue')
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import(/* webpackChunkName: "support" */ '../views/Faq.vue')
  },
  { 
    path: '*',
    name: 'FourOFour',
    component: () => import(/* webpackChunkName: "404" */ '../views/FourOFour.vue')
  },
  { 
    path: '/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "404" */ '../views/Account.vue'),
    meta: {
      authRequired: true
    }
  },
  { 
    path: '/upgrade',
    name: 'Upgrade',
    component: () => import(/* webpackChunkName: "404" */ '../views/Upgrade.vue')
  },
  { 
    path: '/success',
    name: 'Success',
    component: () => import(/* webpackChunkName: "404" */ '../views/Success.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    const userAuth = store.state.authentication.user
    if (!userAuth) {
      next({
        path: '/',
        query: { redirect: 'noAuth' }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
